import { useTRPC } from "@/trpc/client";
import { useQuery } from "@tanstack/react-query";
import type { FeedbackRecord } from "@graftus/schema";
import { useMemo } from "react";

export function useMessageFeedback(
  businessId: string | undefined,
  threadId: string | undefined | null,
) {
  const trpc = useTRPC();
  const query = useQuery(
    trpc.salesTeams.listMessageFeedback.queryOptions(
      { businessId: businessId ?? "", threadId: threadId ?? "" },
      { enabled: Boolean(businessId && threadId) },
    ),
  );

  // Index by messageId so callers can do a cheap O(1) lookup per
  // ChatMessage instead of scanning the array on every render.
  const byMessageId = useMemo(() => {
    const map = new Map<string, FeedbackRecord>();
    if (!query.data) return map;
    for (const row of query.data as FeedbackRecord[]) {
      map.set(row.messageId, row);
    }
    return map;
  }, [query.data]);

  return { ...query, byMessageId };
}
